/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Not_IncludedInputs */



/**
* | output |
* | --- |
* | "Not included" |
*
* @param {Signup_Compare_Not_IncludedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_not_included = /** @type {((inputs?: Signup_Compare_Not_IncludedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Not_IncludedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Not included")
	if (locale === "de") return /** @type {LocalizedString} */ ("Not included")
	if (locale === "it") return /** @type {LocalizedString} */ ("Not included")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Not included")
	if (locale === "es") return /** @type {LocalizedString} */ ("Not included")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Not included")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Not included")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Not included")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Not included")
	return /** @type {LocalizedString} */ ("Not included")
});